<!--  -->
<template>
  <div class="box">
    <van-tabs v-model="active">
      <van-tab :title="item.name" v-for="item in chemiclaList" :key="item.id">
        <div class="info">
          <van-cell-group>
            <van-cell title="化学品中文名" :value="item.text1" />
            <van-cell title="其他中文名" :value="item.text2" />
            <van-cell title="化学品英文名" :value="item.text3" />
            <van-cell title="其他英文名" :value="item.text4" />
            <van-cell title="CAS" :value="item.text5" />
            <van-cell title="纯品/混合物" :value="item.text6" />
            <van-cell title="有害物成分" :value="item.text7" />
            <van-cell title="浓度" :value="item.text8" />
            <van-cell title="操作注意事项" :value="item.text9" />
            <van-cell title="储存注意事项" :value="item.text10" />
          </van-cell-group>
        </div>
      </van-tab>
    </van-tabs>
    <div class="btns">
      <van-button type="info" @click="handleSafe">禁忌表格</van-button>
      <div style="margin-top: 20px">
        <van-button type="info" @click="handleCheck">安全考核</van-button>
      </div>
    </div>
  </div>
</template>
  
  <script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      active: 0,
      chemiclaList: [
        {
          name: "甲醛",
          id: 1,
          text1: "甲醛",
          text2: "暂无",
          text3: "formaldehyde",
          text4: "methanal",
          text5: "50-00-0",
          text6: "混合物",
          text7: "甲醛",
          text8: "暂无",
          text9:
            "密闭操作，提供充分的局部排风。操作人员必须经过专门培训，严格遵守操作规程。建议操作人员佩戴自吸过滤式防毒面具（全面罩），穿橡胶耐酸碱服，戴橡胶手套。远离火种、热源，工作场所严禁吸烟。使用防爆型的通风系统和设备。防止蒸气泄漏到工作场所空气中。避免与氧化剂、酸类、碱类接触。搬运时要轻装轻卸，防止包装及容器损坏。配备相应品种和数量的消防器材及泄漏应急处理设备。倒空的容器可能残留有害物。",
          text10:
            "储存于阴凉、通风的库房。远离火种、热源。M40包装要求密封，不可与空气接触。应与氧化剂、酸类、碱类分开存放，切忌混储。采用防爆型照明、通风设施。禁止使用易产生火花的机械设备和工具。储区应备有泄漏应急处理设备和合适的收容材料。",
        },
        {
          name: "苯巴比妥*",
          id: 2,
          text1: "苯巴比妥*",
          text2: "暂无",
          text3: "Phenobarbital",
          text4: "暂无",
          text5: "50-06-6",
          text6: "暂无",
          text7: "暂无",
          text8: "暂无",
          text9: "暂无",
          text10: "暂无",
        },
        {
          name: "丝裂霉素C",
          id: 3,
          text1: "丝裂霉素C",
          text2: "丝裂霉素C；丝裂霉素；自力霉素；嘧吡霉素；突变霉素；密吐霉素",
          text3: "Mitomycin C",
          text4: "Mitomycin C;Mitomycin;Ametycine;Mutamycin;MMC",
          text5: "50-07-7",
          text6: "纯品",
          text7: "丝裂霉素C",
          text8: "暂无",
          text9:
            "避免接触皮肤和眼睛。防止粉尘和气溶胶生成。在有粉尘生成的地方，提供合适的排风设备。防止吸入蒸汽和烟雾。 切勿靠近火源。－严禁烟火。采取措施防止静电积聚。",
          text10: "贮存在阴凉处。容器保持紧闭，储存在干燥通风处。",
        },
        {
          name: "乳酸",
          id: 4,
          text1: "乳酸",
          text2: "乳酸",
          text3: "Lactic acid",
          text4: "暂无",
          text5: "50-21-5",
          text6: "暂无",
          text7: "暂无",
          text8: "暂无",
          text9: "暂无",
          text10: "暂无",
        },
        {
          name: "可卡因*",
          id: 5,
          text1: "可卡因**",
          text2: "暂无",
          text3: "Cocaine",
          text4: "暂无",
          text5: "50-36-2",
          text6: "暂无",
          text7: "暂无",
          text8: "暂无",
          text9: "暂无",
          text10: "暂无",
        },
        {
          name: "麦角二乙胺",
          id: 6,
          text1: "麦角二乙胺",
          text2: "暂无",
          text3: "(+)- Lysergide",
          text4: "暂无",
          text5: "50-37-3",
          text6: "暂无",
          text7: "暂无",
          text8: "暂无",
          text9: "暂无",
          text10: "暂无",
        },
        {
          name: "山梨醇",
          id: 7,
          text1: "山梨醇",
          text2: "暂无",
          text3: "Sorbitol",
          text4: "暂无",
          text5: "50-70-4",
          text6: "暂无",
          text7: "暂无",
          text8: "暂无",
          text9: "暂无",
          text10: "暂无",
        },
        {
          name: "维生素C",
          id: 8,
          text1: "维生素C",
          text2: "暂无",
          text3: "Ascorbic Acid",
          text4: "暂无",
          text5: "50-81-7",
          text6: "暂无",
          text7: "暂无",
          text8: "暂无",
          text9: "暂无",
          text10: "暂无",
        },
      ],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    handleCheck() {
      this.$router.push("/checkAccess");
    },
    handleSafe() {
      this.$router.push("/tabooInfo");
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
  <style lang='scss' scoped>
//@import url(); 引入公共css类
.box {
  height: calc(100vh);
  padding: 16px;
  overflow-y: auto;
  .info {
    padding: 16px 0;
  }
  .btns {
    position: absolute;
    right: 16px;
    top: 50%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/scan2.vue